











































































// import ProjectCreationContainer from "./project/ProjectCreationContainer";
import {Component, Vue} from 'vue-property-decorator';

import {agencyStore, designStore, lccaStore, perRoadStore, projectStore, userStore} from '@/store/store';
// import {RecursiveFolder} from '@components/Projects/RecursiveFolder.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import {BaseScenarioType, IBaseScenario} from "@/lib/types/IBaseScenario";
import {DesignScenarioType, IDesignBaseScenario} from "@/modules/design/interfaces/shared";
import {IAcOverlayDesignImperial} from "@/modules/design/interfaces/acOverlay";
import {IAsphaltDesignImperial} from "@/modules/design/interfaces/newAsphalt";
import {IConcreteDesignImperial} from "@/modules/design/interfaces/newConcrete";
import {IPorousDesignImperial} from "@/modules/design/interfaces/porous";
import {ILccaCalculatedImperial} from "@/modules/lcca/interfaces/lccaCalculated";
import {IPerRoadScenarioImperial} from "@/modules/perRoad/interfaces/perRoad";
import {IAgencyCostImperial} from "@/modules/agencyCost/interfaces/agencyCost";
import {IProjectMetadata} from "@/interfaces/report";

@Component({
  name: 'Projects',
  components: {
    PxTextEntryBox,
    PxTextArea,
  },
})
export default class Projects extends Vue {
  scenarios: any[] = [];

  selectedScenario: { id: number, scenario: IBaseScenario } | null = null;

  setSelectedScenario(sharedScenario: { id: number, scenario: IBaseScenario }) {
    this.selectedScenario = sharedScenario;
  }

  projects: IProjectMetadata[] = [];

  selectedProject: IProjectMetadata | null = null;

  get projectOptions() {
    return this.projects.map(p => {
      return {text: p.name, value: p}
    })
  }

  fields = [
    'name',
    'type',
    'shared_by',
    'created',
    'actions'
  ]

  saveScenario() {
    /*
    Take the shared scenario JSON and save it using the correct api call
     */

    if (this.selectedScenario === null || this.selectedProject === null) {
      return null
    }

    const scenario = this.selectedScenario.scenario;

    scenario.id = null;
    scenario.user = null;
    scenario.project = this.selectedProject.id;

    this.performSave(scenario).then(response => {
      console.log(response)
      if (this.selectedScenario) {
        projectStore.deleteSharedScenario(this.selectedScenario.id).then(() => {
          this.$bvModal.hide('select-project-id-modal');
          this.update();
        })
      }
    })
  }

  deleteSharedScenario(id: number) {
    projectStore.deleteSharedScenario(id).then(() => {
      this.update();
    })
  }

  performSave(scenario: IBaseScenario) {
    switch (scenario.scenarioType) {
      case BaseScenarioType.design: {
        const designScenario = scenario as IDesignBaseScenario;
        switch (designScenario.designScenarioType) {
          case DesignScenarioType.acOverlay:
            return designStore.saveNewAcOverlayScenario(scenario as IAcOverlayDesignImperial)
          case DesignScenarioType.asphalt:
            return designStore.saveNewAsphaltScenario(scenario as IAsphaltDesignImperial)
          case DesignScenarioType.concrete:
            return designStore.saveNewConcreteScenario(scenario as IConcreteDesignImperial)
          case DesignScenarioType.porous:
            return designStore.saveNewPorousScenario(scenario as IPorousDesignImperial)
        }
        break;
      }
      case BaseScenarioType.lcca:
        return lccaStore.saveNewScenario(scenario as ILccaCalculatedImperial)
      case BaseScenarioType.perRoad:
        return perRoadStore.saveNewScenario(scenario as IPerRoadScenarioImperial)
      case BaseScenarioType.agencyCost:
        return agencyStore.saveNewScenario(scenario as IAgencyCostImperial)
    }
    return new Promise(() => null)
  }

  update() {
    projectStore.loadSharedScenarios().then((scenarios) => {
      this.scenarios = scenarios;
    });

    projectStore.loadAvailableProjects().then(projects => {
      this.projects = projects
    })

    userStore.reloadUser();
  }

  mounted() {
    this.update()
  }
}

